import * as caseDataCollectTypes from './caseDataCollectTypes';

const initialState = {
  menuDetails: [],
  reviewSubmit: false,
  reloadOnToggleChange: false,
  menusLoaded: false,
  isTaskDocument: false,
  isReloaded: false,
  caseHeaderDetails: null,
  refreshPage: false,
  isLoading: false,
  page: {},
  menu: [],
  menuIndex: 0,
};

const caseDataCollectReducer = (state = initialState, action) => {
  switch (action.type) {
    case caseDataCollectTypes.SET_CASE_DETAIL_SUCCESS:
      return {
        ...state,
        menusLoaded: true,
        menuDetails: action.payload,
        isReloaded: action.isReloaded,
      };
    case caseDataCollectTypes.SET_CASE_SUBMIT_SUCCESS:
      return {
        ...state,
        menusLoaded: true,
        reviewSubmit: action.payload,
      };
    case caseDataCollectTypes.SET_RELOAD_ON_TOGGLE:
      return {
        ...state,
        menusLoaded: true,
        reloadOnToggleChange: action.payload,
      };
    case caseDataCollectTypes.SET_QUESTIONNAIRE_PAGE: {
      return {
        ...state,
        page: action.payload,
        isLoading: false,
      };
    }
    case caseDataCollectTypes.SET_QUESTIONNAIRE_MENU: {
      return {
        ...state,
        menu: action.payload.menu,
        menuIndex: action.payload.index,
      };
    }
    case caseDataCollectTypes.SET_REFRESH_ON_PAGE:
      return {
        ...state,
        refreshPage: action.payload,
      };
    case caseDataCollectTypes.SET_TASK_DOCUMENT_DISABLED_STATUS:
      return {
        ...state,
        isTaskDocument: action.payload,
      };
    case caseDataCollectTypes.RESET_IS_RELOADED:
      return {
        ...state,
        isReloaded: false,
      };
    case caseDataCollectTypes.SET_CASE_HEADER_DETAIL_SUCCESS:
      return {
        ...state,
        caseHeaderDetails: action.payload,
      };
    case caseDataCollectTypes.RESET_QUESTIONNAIRE:
      return {
        ...initialState,
        menuDetails: state.menuDetails,
        caseHeaderDetails: state.caseHeaderDetails,
      };
    default:
      return state;
  }
};

export default caseDataCollectReducer;
